export const initialState = {
  fixedAssets: [],
  fixedAssetsLoading: false,
  fixedAssetNextTokens: { 1: null },
  fixedAssetsError: null,
  newFixedAsset: "",
  newFixedAssetLoading: false,
  newFixedAssetError: null,
  fixedAssetID: "",
  updateFixedAssetLoading: false,
  updateFixedAssetError: null,
  deleteFixedAssetLoading: false,
  deleteFixedAssetError: null,
  deletedID: "",
  fixedAsset: {},
  fixedAssetLoading: false,
  fixedAssetError: null,
  depreciations: [],
  depreciationsLoading: false,
  depreciationsError: null,
  runDepreciationResult: null,
  runDepreciationLoading: false,
  runDepreciationError: null,
  disposeResult: null,
  disposeLoading: false,
  disposeError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_FIXED_ASSET":
      return {
        ...state,
        request: action.payload.request,
        fixedAssets: [],
        fixedAssetsLoading: true,
        fixedAssetsError: null,
        fixedAssetNextTokens:
          action.payload.page === 1
            ? initialState.fixedAssetNextTokens
            : state.fixedAssetNextTokens,
      };
    case "LIST_FIXED_ASSET_SUCCESS":
      return {
        ...state,
        request: null,
        fixedAssets: action.payload.items,
        fixedAssetsLoading: false,
        fixedAssetNextTokens: {
          ...state.fixedAssetNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_FIXED_ASSET_ERROR":
      return {
        ...state,
        request: null,
        fixedAssetsLoading: false,
        fixedAssetsError: action.error,
      };
    case "REQUEST_GET_FIXED_ASSET":
      return {
        ...state,
        request: action.payload.request,
        fixedAsset: {},
        fixedAssetLoading: true,
        fixedAssetError: null,
      };
    case "GET_FIXED_ASSET_SUCCESS":
      return {
        ...state,
        request: null,
        fixedAsset: action.payload.asset,
        fixedAssetLoading: false,
      };
    case "GET_FIXED_ASSET_ERROR":
      return {
        ...state,
        request: null,
        fixedAssetLoading: false,
        fixedAssetError: action.error,
      };
    case "REQUEST_CREATE_FIXED_ASSET":
      return {
        ...state,
        request: action.payload.request,
        newFixedAsset: "",
        newFixedAssetError: null,
        newFixedAssetLoading: true,
      };
    case "SUCCESS_CREATE_FIXED_ASSET":
      return {
        ...state,
        request: null,
        newFixedAsset: action.payload.asset,
        fixedAssets: [action.payload.asset, ...state.fixedAssets],
        newFixedAssetLoading: false,
      };
    case "ERROR_CREATE_FIXED_ASSET":
      return {
        ...state,
        request: null,
        newFixedAssetLoading: false,
        newFixedAssetError: action.error,
      };
    case "REQUEST_UPDATE_FIXED_ASSET":
      return {
        ...state,
        request: action.payload.request,
        fixedAssetID: "",
        updateFixedAssetError: null,
        updateFixedAssetLoading: true,
      };
    case "UPDATE_FIXED_ASSET_SUCCESS": {
      const { asset } = action.payload;
      return {
        ...state,
        request: null,
        fixedAssetID: asset.id,
        updateFixedAssetLoading: false,
        fixedAssets: state.fixedAssets.map((item) =>
          item.id === asset.id ? asset : item
        ),
      };
    }
    case "ERROR_UPDATE_FIXED_ASSET":
      return {
        ...state,
        request: null,
        updateFixedAssetLoading: false,
        updateFixedAssetError: action.error,
      };
    case "REQUEST_DELETE_FIXED_ASSET":
      return {
        ...state,
        request: action.payload.request,
        deleteFixedAssetLoading: true,
        deleteFixedAssetError: null,
        deletedID: "",
      };
    case "DELETE_FIXED_ASSET_SUCCESS":
      return {
        ...state,
        request: null,
        fixedAssets: state.fixedAssets.filter(
          (asset) => asset.id !== action.payload.id
        ),
        deleteFixedAssetLoading: false,
        deletedID: action.payload.id,
      };
    case "DELETE_FIXED_ASSET_ERROR":
      return {
        ...state,
        request: null,
        deleteFixedAssetLoading: false,
        deleteFixedAssetError: action.error,
      };
    case "REQUEST_LIST_DEPRECIATION":
      return {
        ...state,
        request: action.payload.request,
        depreciations: [],
        depreciationsLoading: true,
        depreciationsError: null,
      };
    case "LIST_DEPRECIATION_SUCCESS":
      return {
        ...state,
        request: null,
        depreciations: action.payload.items,
        depreciationsLoading: false,
      };
    case "LIST_DEPRECIATION_ERROR":
      return {
        ...state,
        request: null,
        depreciationsLoading: false,
        depreciationsError: action.error,
      };
    case "REQUEST_RUN_DEPRECIATION":
      return {
        ...state,
        runDepreciationResult: null,
        runDepreciationError: null,
        runDepreciationLoading: true,
      };
    case "RUN_DEPRECIATION_SUCCESS":
      return {
        ...state,
        runDepreciationResult: action.payload.result,
        runDepreciationLoading: false,
      };
    case "RUN_DEPRECIATION_ERROR":
      return {
        ...state,
        runDepreciationError: action.error,
        runDepreciationLoading: false,
      };
    case "REQUEST_DISPOSE_FIXED_ASSET":
      return {
        ...state,
        disposeResult: null,
        disposeError: null,
        disposeLoading: true,
      };
    case "DISPOSE_FIXED_ASSET_SUCCESS": {
      const { result } = action.payload;
      return {
        ...state,
        disposeResult: result,
        disposeLoading: false,
        fixedAssets: state.fixedAssets.map((item) =>
          item.id === result?.assetID
            ? { ...item, status: "DISPOSED" }
            : item
        ),
      };
    }
    case "DISPOSE_FIXED_ASSET_ERROR":
      return {
        ...state,
        disposeError: action.error,
        disposeLoading: false,
      };
    case "CLEAR_FIXED_ASSET":
      return {
        ...state,
        newFixedAsset: "",
        fixedAssetID: "",
        fixedAsset: {},
        deletedID: "",
        runDepreciationResult: null,
        disposeResult: null,
      };
    // Leaves fixedAssetsError alone: closing a modal must not turn a failed
    // list load into an empty list. The next list request resets it.
    case "CLEAR_FIXED_ASSET_ERROR":
      return {
        ...state,
        newFixedAssetError: null,
        updateFixedAssetError: null,
        deleteFixedAssetError: null,
        runDepreciationError: null,
        disposeError: null,
      };
    default:
      return state;
  }
};
